import {useEffect, useState} from 'react';

const Validate = props => {
    const {validate, onSuccess = () => {}, onError = () => app.history.replace('..'), children} = props,
        [allow, setAllow] = useState(false),
        [checked, setChecked] = useState(false);

    useEffect(() => {
        try {
            validate(app.store.getState());
            setAllow(true);
        } catch (err) {
            console.warn(err);
        }
        setChecked(true);
    }, [validate]);

    useEffect(() => {
        if (checked) {
            if (allow) onSuccess();
            else onError();
        }
    }, [checked]);

    if (!checked || !allow) return null;

    return children;
};

export default Validate;
